import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Bot, Sparkles, Target, Users, ArrowRight } from 'lucide-react';
import NatureImageCarousel from './NatureImageCarousel';

export default function Hero() {
  const [showChangelog, setShowChangelog] = useState(false);
  
  return (
    <div className="relative overflow-hidden bg-gradient-to-b from-blue-50 to-white pt-32 pb-16">
      {/* Nature Image Carousel */}
      <NatureImageCarousel />
      
      <div className="fixed top-16 left-0 right-0 bg-gradient-to-r from-blue-500 to-indigo-600 text-white py-4 z-30">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link 
            to="/contactmanager"
            className="flex items-center justify-center space-x-3 hover:bg-white/20 transition-all group px-4 py-2 rounded-lg cursor-pointer"
          >
            <Users className="w-6 h-6" />
            <span className="text-lg font-medium">🎉 NEW: Contact Manager - The Simple Way to Organize Business Contacts</span>
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mt-16">
          <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6 mt-16">
            Welcome to Gekko HQ
            <span className="block text-blue-500 text-3xl md:text-4xl mt-2">Your ultimate business management solution!</span>
          </h1>
          <p className="text-2xl text-gray-600 mb-4 max-w-2xl mx-auto">
            Meet the Gekkos: Your AI Management Team
          </p>
          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto opacity-90">
            A friendly team of AI specialists ready to help grow your business with a smile
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4 mb-12">
            <Link 
              to="/signup"
              className="bg-gradient-to-r from-blue-500 to-indigo-600 text-white px-8 py-3 rounded-full hover:shadow-lg transition-all flex items-center justify-center space-x-2 group"
            >
              <Sparkles className="w-5 h-5" />
              <span>Get Started Free</span>
            </Link>
            <Link 
              to="/login"
              className="border-2 border-blue-500 text-blue-600 px-8 py-3 rounded-full hover:bg-blue-50 transition-all flex items-center justify-center space-x-2"
            >
              <Bot className="w-5 h-5" />
              <span>Sign In</span>
            </Link>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto mb-16">
            {[
              {
                icon: <Bot className="w-8 h-8 text-purple-500" />,
                title: 'Kari - Your Personal Assistant Gekko',
                description: 'Your friendly and dedicated personal assistant, managing your daily tasks and coordinating your AI team with a smile'
              },
              {
                icon: <Sparkles className="w-8 h-8 text-blue-500" />,
                title: 'Kaizen - Your Business Development Gekko',
                description: 'Your enthusiastic business development buddy, helping you plan and grow your business with positive energy'
              },
              {
                icon: <Target className="w-8 h-8 text-blue-500" />,
                title: 'Ninja - Your Operations Gekko',
                description: 'Your friendly helper who keeps your business processes running smoothly and efficiently'
              }
            ].map((feature, index) => (
              <div key={index} className="bg-white/80 backdrop-blur-sm p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow">
                <div className="flex flex-col items-center text-center">
                  {feature.icon}
                  <h3 className="mt-4 font-semibold text-gray-900">{feature.title}</h3>
                  <p className="mt-2 text-gray-600 text-sm">{feature.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}